import React, { useRef, useEffect, useCallback, useState } from 'react';

const QrInput = React.memo(({ onChange, value = 0, defaultValue, className, error, placeholder, isBulk = false, quantity = 0 }) => {
  const inputRef = useRef(null);
  const [count, setCount] = useState(0);

  const currentQuantity = value || defaultValue || 0

  const handleChange = useCallback((event) => {
    const { value } = event.target;
    if (/^\d*\.?\d*$/.test(value)) {
      onChange(value);
    }
  }, [onChange]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleIncrement = () => {
    let currentValue = count + 1
    let updatedQuantity = quantity ? parseInt(currentQuantity) + parseInt(quantity) : parseInt(currentQuantity) + parseInt(currentQuantity || 1)
    onChange(updatedQuantity)
    setCount(currentValue);
  };
  
  const handleDecrement = () => {
    let currentValue = Math.max(count - 1, 2)
    let updatedQuantity = quantity ? parseInt(currentQuantity) - parseInt(quantity) : parseInt(currentQuantity) - parseInt(currentQuantity || 1)
    onChange(updatedQuantity)
    setCount(currentValue);
  };


  return (
    <div className={`relative ${className}`}>
      <div className={`flex w-[150px] m-auto`}>
        {/* {isBulk &&
          <div onClick={handleDecrement} className="p-2 border rounded">
            -
          </div>
        } */}
        <input
          ref={inputRef}
          onChange={handleChange}
          value={value}
          className={`border border-solid border-[#858485] rounded-lg bg-white mx-2 px-3 py-2 ${error ? 'border-red-500' : ''}`}
          placeholder={placeholder || 'Enter'}
          style={{ outline: 'none', width: isBulk ? '120px' : '150px' }}
        />
        {/* {isBulk &&
          <div onClick={handleIncrement} className="p-2 border rounded">
            +
          </div>
        } */}
      </div>
      {error?.message ? <div style={{color: 'red', fontSize: '12px'}}>{error?.message}</div>: null}
    </div>
  );
});

export default QrInput;
